/* 会话列表排序 */
export default function(conversationList, conversationKey) {
	const newConversationObj = {}
	let tempArr = []
	let firstItem = {}
	// 将新会话放在第一个
	conversationList = JSON.parse(JSON.stringify(conversationList))
	for (let key in conversationList) {
		if (conversationKey == conversationList[key].conversationKey) {
			tempArr.unshift(conversationList[key])
		} else {
			tempArr.push(conversationList[key])
		}
	}

	tempArr.forEach((item) => {
		const key = item.conversationKey
		return (newConversationObj[key] = item)
	})
	return newConversationObj
}